import React from 'react';
import { Input } from './Input';

export const renderInput = ({
  input,
  placeholder,
  meta: { touched, error },
  defaultValue,
  handleChange,
  type,
  loading,
  disabled,
  maxLength
}) =>
(
  <Input
    {...input}
    type={type}
    name={input.name}
    placeholder={placeholder}
    handleChangeInput = {input.onChange}
    handleChange={handleChange}
    handleBlur={input.onBlur}
    maxLength={maxLength}
    error={touched && error}
    value={defaultValue}
    loading={loading}
    disabled={disabled}
  />
);
